import { jsx as _jsx } from "react/jsx-runtime";
import { Selector, Util } from 'ui-lib';
import { TeamRole } from 'lib/api/api-types';
import * as React from 'react';
export function TeamRoleSelector(props) {
    var choices = Util.idNamePairsFromEnum(TeamRole);
    return _jsx(Selector, { name: props.name, items: choices, label: "Role" });
}
